//开票定义

import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    DIRECT_SUPPLIER = new Meta(1, "直采-供应商");
    JOINT_SUPPLY_CHAIN = new Meta(2, "联合采购-联合采购商");
    JOINT_SUPPLIER = new Meta(3, "联合采购-下游采购商");
}

export const TYPE = new Type();
